import { lineItemHelpers } from '@reveni-io/reveni-ui'

export const getCreateReturnPayload = ({
  items,
  sessionId,
  seonBase64,
  joinGroup,
  giftRecipient,
  returnPortalId,
  seonStreamId,
}) => {
  const { getItemForPayload } = lineItemHelpers()
  const payload = {
    line_items: items.map(item => getItemForPayload(item)),
    join_group: joinGroup,
    portal_id: returnPortalId,
  }

  if (sessionId) payload.session_id = sessionId

  if (seonBase64) payload.fingerprint_payload = seonBase64

  if (giftRecipient) payload.gift_recipient = giftRecipient

  if (seonStreamId) payload.stream_id = seonStreamId

  return payload
}
